/* slugify.js — pure client-side slug helper.
 *
 * Normalises raw user input ("Shopify Development", "/About!", "café-au-lait")
 * into a safe URL path like "/shopify-development", "/about", "/cafe-au-lait".
 *
 * Mirrors the server-side `slugify_path` in `/app/backend/server.py`.
 */

export function slugify(raw) {
  if (raw == null) return "";
  let s = String(raw).trim();
  // Strip protocol + domain if user pasted a full URL
  s = s.replace(/^[a-z]+:\/\/[^/]+/i, "");
  // Decompose accents (café → cafe)
  s = s.normalize("NFKD").replace(/[\u0300-\u036f]/g, "");
  s = s.toLowerCase();
  // Replace any run of non-[a-z0-9] with a single dash
  s = s.replace(/[^a-z0-9]+/g, "-");
  s = s.replace(/^-+|-+$/g, ""); // trim leading/trailing dashes
  if (!s) return "";
  return `/${s}`;
}
